import { render, staticRenderFns } from "./IndoorAirNavBar.vue?vue&type=template&id=4b8327f0&scoped=true&"
import script from "./IndoorAirNavBar.vue?vue&type=script&lang=js&"
export * from "./IndoorAirNavBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8327f0",
  null
  
)

export default component.exports